export const EVENTS = {
  ADDED_COURSE: "added-course",
  ENROLLED_TO_COURSE: "enrolled-to-course",
  LEARNER_VIEW_SWITCHED: "learner-view-switched",
  ADDED_USER: "added-user",
  ADDED_GROUP: "added-group",
  EXPLORED_REPORTS: "explored-reports",
  CUSTOMIZED_PORTAL: "customized-portal",
};

export const CHECKLIST_ITEMS_INTERNAL_IDS = {
  CREATE_YOUR_TALENTLMS_PORTAL: "create-your-talentlms-portal",
  CREATE_YOUR_FIRST_COURSE_IN_SECONDS_WITH_AI: "create-your-first-course-in-seconds-with-ai",
  ASSIGN_COURSES_WITH_EASE: "assign-courses-with-ease",
  EXPERIENCE_A_COURSE_AS_A_LEARNER: "experience-a-course-as-a-learner",
  INVITE_LEARNERS_TO_START_TRAINING: "invite-learners-to-start-training",
  ORGANIZE_TRAINING_EFFORTLESSLY_WITH_GROUPS: "organize-training-effortlessly-with-groups",
  TRACK_PROGRESS_WITH_POWERFUL_REPORTS: "track-progress-with-powerful-reports",
  CUSTOMIZE_YOUR_PORTAL_TO_MATCH_YOUR_BRAND: "customize-your-portal-to-match-your-brand",
};

export const ONBOARDING_CHECKLIST_ID = 2303;

export const INJECTION_DELAY_MS = 2500;

export const WORKSPACE_CODE = "DBHh2cw9gJfbFvHc";

export const TOUR_ITEMS_IDS = {
  SWITCH_TO_ADMIN: 99008,
  TAKE_A_COURSE_YOURSELF: 97498,
  REPORTS_THE_INSIGHTS_YOU_NEED_WHEN_YOU_NEED_THEM: 97795,
  LETS_GET_ORGANIZED_SMARTLY: 95506,
  ASSIGN_A_COURSE_TO_A_USERS_AND_TAKE_THE_COURSE: 97499,
  CUSTOMIZE_YOUR_ACCOUNT: 95029,
  INVITE_A_LEARNER: 95218,
  CREATE_YOUR_FIRST_COURSE_IN_SECONDS_WITH_OR_WITHOUT_AI: 94948,
  WELCOME_USERS: 94932,
};

export const ADMIN_CARD_TOUR_CARD_IDS = [
  "c6e91a7d-0f04-436d-bb7c-81b7c2bfc0b9",
  "390e685b-1705-4e19-ba81-0137e5a797fe",
];

export const GENERIC_CARD_TOUR_IDS = {
  SET_ROLE_CARD: "481a3398-bd9c-4fcc-9250-e64bf2d2a071",
};

export const CHECKLISTS_TO_TOURS_MAP: Record<string, number> = {
  [CHECKLIST_ITEMS_INTERNAL_IDS.CREATE_YOUR_FIRST_COURSE_IN_SECONDS_WITH_AI]:
    TOUR_ITEMS_IDS.CREATE_YOUR_FIRST_COURSE_IN_SECONDS_WITH_OR_WITHOUT_AI,

  [CHECKLIST_ITEMS_INTERNAL_IDS.ASSIGN_COURSES_WITH_EASE]:
    TOUR_ITEMS_IDS.ASSIGN_A_COURSE_TO_A_USERS_AND_TAKE_THE_COURSE,

  [CHECKLIST_ITEMS_INTERNAL_IDS.EXPERIENCE_A_COURSE_AS_A_LEARNER]:
    TOUR_ITEMS_IDS.TAKE_A_COURSE_YOURSELF,

  [CHECKLIST_ITEMS_INTERNAL_IDS.INVITE_LEARNERS_TO_START_TRAINING]: TOUR_ITEMS_IDS.INVITE_A_LEARNER,

  [CHECKLIST_ITEMS_INTERNAL_IDS.ORGANIZE_TRAINING_EFFORTLESSLY_WITH_GROUPS]:
    TOUR_ITEMS_IDS.LETS_GET_ORGANIZED_SMARTLY,

  [CHECKLIST_ITEMS_INTERNAL_IDS.TRACK_PROGRESS_WITH_POWERFUL_REPORTS]:
    TOUR_ITEMS_IDS.REPORTS_THE_INSIGHTS_YOU_NEED_WHEN_YOU_NEED_THEM,

  [CHECKLIST_ITEMS_INTERNAL_IDS.CUSTOMIZE_YOUR_PORTAL_TO_MATCH_YOUR_BRAND]:
    TOUR_ITEMS_IDS.CUSTOMIZE_YOUR_ACCOUNT,
};
